import React from 'react';

interface IProps  {
    id?: string,
    cssClass?: string,
    disabled?: boolean,
    children?: any,
    clicked?: () => void,
}

export const Button = (props: IProps) : JSX.Element => {
    if (props.disabled) {
        return (
            <button type="button" id={props.id} className={props.cssClass} disabled>{props.children}</button>
        );
    }
    return (
        <button type="button" id={props.id} className={props.cssClass} onClick={props.clicked}>{props.children}</button> 
    );
};
